import { Category } from 'types/schema';
import { convertStringToSlug } from 'utils/generateProductSlug';

/**
 * Resolve top-level parent category id from a subcategory URL path
 * like `/trai-cay-rau-cu/rau-cu-tuoi-c16` or `/veggies-fruit/vegetable-c16`.
 */
const getParentCategoryIdFromPathname = (pathname: string, categories: Category[] = []): number | undefined => {
  if (!pathname || !categories.length) {
    return undefined;
  }

  const segments = pathname.replace(/^\//, '').split('/').filter(Boolean);

  if (segments.length < 2) {
    return undefined;
  }

  const parentSlug = segments[0];

  const parent = categories.find((category) => {
    const nameLocalSlug = convertStringToSlug(category.nameLocal || '');

    const nameSlug = convertStringToSlug(category.name || '');

    return nameLocalSlug === parentSlug || nameSlug === parentSlug;
  });

  return parent?.id ?? undefined;
};

export default getParentCategoryIdFromPathname;
